// eslint-disable-next-line import/no-unresolved
import { Feature, FeatureCollection, Point } from "geojson";
import { GENERATOR_TYPE_TO_AVAILABILITY_SIZE_TO_USE } from "sharedStyles/capacityColorStyles";
import { Bus, ScopedBus } from "types/busType";
import { GeneratorType } from "types/generatorType";

export const BUS_ID_KEY: keyof GeojsonScopedBus = "id";
export const NIRA_BUS_ID_KEY: keyof GeojsonScopedBus = "niraBusId";
export const SIZE_KEY: keyof GeojsonScopedBus = "size";
export const CONSTRAINT_COUNT_KEY: keyof GeojsonScopedBus = "constraintCount";

export type GeojsonScopedBus = {
    readonly id: string;
    readonly niraBusId: string;
    readonly size: number;
    readonly constraintCount: number;
};

export const getBusGeojson = (
    scopedBuses: ReadonlyArray<ScopedBus>,
    generatorType: GeneratorType
): Readonly<FeatureCollection> => {
    const sizeCalculatorFunction =
        GENERATOR_TYPE_TO_AVAILABILITY_SIZE_TO_USE[generatorType];

    const scopedBusFeatureList: Feature<Point, GeojsonScopedBus>[] =
        scopedBuses.map((scopedBus) => {
            return getFeature(
                scopedBus.bus,
                sizeCalculatorFunction(scopedBus.scopedCapacityEnergyCost),
                scopedBus.zeroMwConstraintCount ?? 0
            );
        });
    return {
        type: "FeatureCollection",
        features: scopedBusFeatureList
    };
};

const getFeature = (
    bus: Bus,
    size: number,
    constraintCount: number
): Readonly<Feature<Point, GeojsonScopedBus>> => {
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: [bus.longitude, bus.latitude]
        },
        properties: {
            id: bus.id,
            niraBusId: bus.niraBusId,
            size: size,
            constraintCount: constraintCount
        }
    };
};
